import axios from 'axios';
import config from 'config';
import { v4 } from 'uuid';
import { getAiAuthorizationClaims } from './aiChatAuthHelpers';

const {
  cognitiveLayer: {
    api: { dev: devUrl },
    endpoints: {
      aiWorkspace: { reconcileProblem },
    },
  },
} = config;

const stableSerialize = (value) => {
  if (Array.isArray(value)) return `[${value.map(stableSerialize).join(',')}]`;
  if (value && typeof value === 'object') {
    return `{${Object.keys(value)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${stableSerialize(value[key])}`)
      .join(',')}}`;
  }
  return JSON.stringify(value);
};

const hashDraft = (draft) => {
  const text = stableSerialize(draft);
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16);
};

export const getAiProblemIdempotencyKey = ({ workspaceId, sourceProblem, editedProblem }) =>
  `avalon:${workspaceId}:${sourceProblem.artifact}:${sourceProblem.version}:${hashDraft(editedProblem)}`;

export const reconcileAiWorkspaceProblem = async ({
  workspaceId,
  sourceProblem,
  editedProblem,
  idempotencyKey = getAiProblemIdempotencyKey({ workspaceId, sourceProblem, editedProblem }),
}) => {
  if (!workspaceId || !sourceProblem?.artifact || !Number.isInteger(sourceProblem?.version)) {
    throw new Error('Workspace and source Problem version are required');
  }

  const url = reconcileProblem.replace('{workspaceId}', encodeURIComponent(workspaceId));
  const response = await axios.post(
    `${devUrl}${url}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {
      sourceProblem,
      editedProblem,
      idempotencyKey: idempotencyKey || v4(),
    },
    {
      headers: {
        'Authorization-Claims': getAiAuthorizationClaims(),
      },
    },
  );
  return response.data?.data;
};
